// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-availability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-availability/taf-availability.js';

mount([g0]);
